import { get } from 'lodash';
import { resolve } from 'redux-optimist-promise';
import createReducer from 'Store/utils/createReducer';

import { FETCH_PROPOSALS_BY_ID } from 'Store/booking/proposals/constants';
import { UPDATE_TRIP_DATE_CRITERIA, SYNC_WITH_LOCATION } from 'Store/constants';
import { formatDate } from 'Utils/date/dateUtils';
import { QUERY_DATE_FORMAT, QUERY_DEPARTURE_DATE } from 'Utils/uri/constants';

const initialState = {
  departureDate: null,
  arrivalDate: null,
};

export default createReducer(initialState, {
  [SYNC_WITH_LOCATION](state, { payload }: Action<any>) {
    if (!payload.location.queryParams[QUERY_DEPARTURE_DATE]) {
      return state;
    }

    const formattedDate = formatDate('YYYYMMDD')(
      payload.location.queryParams[QUERY_DEPARTURE_DATE],
      QUERY_DATE_FORMAT,
    );

    return {
      arrivalDate: Number(formattedDate),
      departureDate: Number(formattedDate),
    };
  },
  [resolve(FETCH_PROPOSALS_BY_ID)](state, action) {
    const [proposal] = get(action, 'payload.proposals.proposals', [initialState]);
    if (proposal) {
      const { arrivalDate, departureDate } = proposal;
      return {
        arrivalDate: Number(arrivalDate),
        departureDate: Number(departureDate),
      };
    }

    return state;
  },
  [UPDATE_TRIP_DATE_CRITERIA](_state, action) {
    const day = get(action, 'payload.day', {});
    const departureDate = Number(get(day, 'id')) || null;
    const arrivalDate = Number(get(day, 'arrivalDate', departureDate)) || null;

    return {
      departureDate,
      arrivalDate,
    };
  },
});
